import { Component, OnInit, ViewContainerRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { NotificationService } from '../../../../shared/utils/notification.service';
import { BaseGeneral } from '../../../../shared/utils/BaseGeneral';
import { BodyService } from '../../../../shared/utils/body.service';
import { JsonApiService } from '../../../../core/api/json-api.service';
import { UsuarioService } from "../../../../_seguridad/_usuario/usuario.service";

import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { ChangePassword } from '../../../../shared/layout/header/change-password/changePassword';

import { Observable } from "rxjs/Rx";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import 'rxjs/Rx';

declare var $:any;

@Component({
  selector: 'sa-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent extends BaseGeneral implements AfterViewInit {

  @ViewChild('changePasswordForm')
  changePasswordForm: any;
  changePassword: ChangePassword = new ChangePassword();
  public validationOptions: any;
  submitted = false;
  loading = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private usuarioService: UsuarioService,
    protected bodyService: BodyService,
    protected notificationService: NotificationService,
    protected jsonApiService: JsonApiService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef
  ) {
    
    super(bodyService, notificationService, jsonApiService);
    this.toastr.setRootViewContainerRef(vcr);    
  }

  ngOnInit() {
    this.limpiarImput();

    if(this.datai18n == null){
      let i18n = sessionStorage.getItem("defaultLocale");
      if (i18n === "es") {
          this.jsonApiService.fetch('/langs/es.json')
              .subscribe(data => {
                  let datai18n = JSON.stringify(data);
                  localStorage.setItem("datai18n", datai18n);
                  this.asignarValidacion();
              })
          ;
      }
      else {
          this.jsonApiService.fetch('/langs/us.json')
              .subscribe(data => {
                  let datai18n = JSON.stringify(data);
                  localStorage.setItem("datai18n", datai18n);
                  this.asignarValidacion();
              });
      }      
    }else{
      this.asignarValidacion();
    }
  }

  ngAfterViewInit() {    
  }
  
  limpiarImput(){
    this.changePassword = new ChangePassword();
    $("#nuevaClave, #claveActual, #confirmarClave").parent().removeClass("state-error");
    $("#nuevaClave-error, #claveActual-error, #claveActual-confirmarClave").hide();
  }

  asignarValidacion(){
    this.validationOptions = {
      rules: {
        claveActual: {
          required: true,
          minlength: 3,
          maxlength: 100
        },
        nuevaClave: {
          required: true,
          minlength: 3,
          maxlength: 100
        },
        confirmarClave: {
          required: true,
          minlength: 3,
          maxlength: 100,
          equalTo: '#nuevaClave'
        }            
      },
      messages: {
        claveActual: {
          required: this.datai18n['ChangePassord.validacion.claveActual.requerido'],
          minlength: this.datai18n['ChangePassord.validacion.claveActual.minimo'],
          maxlength: this.datai18n['ChangePassord.validacion.claveActual.maximo']
        },
        nuevaClave: {
          required: this.datai18n['ChangePassord.validacion.claveNueva.requerido'],
          minlength: this.datai18n['ChangePassord.validacion.claveNueva.minimo'],
          maxlength: this.datai18n['ChangePassord.validacion.claveNueva.maximo']
        },
        confirmarClave: {
          required: this.datai18n['ChangePassord.validacion.claveConfirmar.requerido'],
          minlength: this.datai18n['ChangePassord.validacion.claveConfirmar.minimo'],
          maxlength: this.datai18n['ChangePassord.validacion.claveConfirmar.maximo'],
          equalTo: this.datai18n['ChangePassord.validacion.claveConfirmar.equalTo']
        }            
      }
    }
  }

  onSubmit(event: any) {
    this.submitted = true;
    let formularioChangePassword = $('#' + this.changePasswordForm.nativeElement.id);
    formularioChangePassword.validate();
    if (formularioChangePassword.valid()) {
      
      event.preventDefault();
      this.loading = true;

      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      this.changePassword.userId = currentUser.userSystem.userId
      this.usuarioService.changePassword(this.changePassword)
      .subscribe(data => {
        this.changePassword = data;
        if(this.changePassword.cambioCorrecto){
          this.actualizarListaRegistroOK(
            this.datai18n['Menu.seguridad.changePassord'],
            this.changePassword.mensajeCambio);          
          
          this.notificationService.smallBoxOK(
            this.changePassword.mensajeCambio,
            this.datai18n.cerrar5segundos);

          this.hidePopupChangePasswordMobile();
        }else{              
            this.notificationService.smallBox({
              title: 'Alert!',
              content: this.changePassword.mensajeCambio,
              color: this.colorError,
              iconSmall: 'fa fa-times-circle',
              timeout: 5000
          });            
        }
         
      },
      error => {
        this.changePassword.claveActual = this.changePassword.claveActualAnterior;
        this.changePassword.confirmarClave = this.changePassword.confirmarClaveAnterior;
        this.changePassword.nuevaClave = this.changePassword.nuevaClaveAnterior;
        
        this.actualizarListaRegistroError(
          this.datai18n['Menu.seguridad.changePassord'],
          error);
        this.mostrarMensajeError(error);
      }
      );      
    }
  }

  showPopupChangePasswordMobile(){
    this.limpiarImput();
    $("#VisualizadorCambioClave").show();
  }  

  hidePopupChangePasswordMobile(){
    this.limpiarImput();
    $("#VisualizadorCambioClave").hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/change-password/change-password.component.ts